export const SUBJECT_ROUTING_REQUEST = "SUBJECT_ROUTING_REQUEST";
export const SUBJECT_ROUTING_SUCCESS = "SUBJECT_ROUTING_SUCCESS";
export const SUBJECT_ROUTING_FAILURE = "SUBJECT_ROUTING_FAILURE";

export const SUBJECT_ROUTING_CREATE_REQUEST = "SUBJECT_ROUTING_CREATE_REQUEST";
export const SUBJECT_ROUTING_CREATE_SUCCESS = "SUBJECT_ROUTING_CREATE_SUCCESS";
export const SUBJECT_ROUTING_CREATE_FAILURE = "SUBJECT_ROUTING_CREATE_FAILURE";

export const SUBJECT_ROUTING_UPDATE_REQUEST = "SUBJECT_ROUTING_UPDATE_REQUEST";
export const SUBJECT_ROUTING_UPDATE_SUCCESS = "SUBJECT_ROUTING_UPDATE_SUCCESS";
export const SUBJECT_ROUTING_UPDATE_FAILURE = "SUBJECT_ROUTING_UPDATE_FAILURE";
